import enTranslation from '../languages/en.json';
import deTranslation from '../languages/de.json';
const translations = {
    en: enTranslation,
    de: deTranslation,
}

export default translations;